<template>
    <div>
        <vue-suggestion :items="filtered_items" v-model="item" :setLabel="setLabel" :itemTemplate="itemTemplate"
            :placeholder="placeholder" @changed="inputChange" @selected="itemSelected">
        </vue-suggestion>
    </div>
</template>


<script>
    import itemTemplate from './itemTemplate.vue';
    export default {
        name: 'CustomSearch',
        components: {
        },
        props: ['items', 'placeholder'],
        data() {
            return {
                filtered_items: [],
                itemTemplate,
                item: {}
            }
        },
        methods: {
            itemSelected(item) {
                this.item = item;
                this.$emit('update', item)
            },
            setLabel(item) {
                return item.name;
            },
            inputChange(text) {
                this.filtered_items = this.items.filter(item => (item.name).toLowerCase().includes(text.toLowerCase()));
            },
        },
        mounted() {
            this.filtered_items = this.items;
        }
    }
</script>


<style>
    .vs__input {
        width: 100%;
        height: 40px
    }

    .vue-suggestion .vs__list {
        width: 100%;
        text-align: left;
        border: none;
        border-top: none;
        max-height: 400px;
        overflow-y: auto;
        border-bottom: 1px solid #023d7b;
        position: relative;
    }

    .vue-suggestion .vs__list .vs__list-item {
        background-color: #fff;
        padding: 10px;
        border-left: 1px solid #023d7b;
        border-right: 1px solid #023d7b;
    }

    .vue-suggestion .vs__list .vs__list-item:last-child {
        border-bottom: none;
    }

    .vue-suggestion .vs__list .vs__list-item:hover {
        background-color: #eee !important;
    }

    .vue-suggestion .vs__list,
    .vue-suggestion .vs__loading {
        position: absolute;
    }

    .vue-suggestion .vs__list .vs__list-item {
        cursor: pointer;
    }

    .vue-suggestion .vs__list .vs__list-item.vs__item-active {
        background-color: #f3f6fa;
    }

    .vs__list {
        z-index: 1;
    }
</style>